import { Delivery } from "../../../types/delivery/delivery";
import { DeliveryDto } from "../../../types/delivery/delivery-dto";
import { convertDeliveryDtoToDelivery } from "../../../utils/converter/delivery/delivery-converter";
import { DeliveryState } from "../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    deliveryDto: DeliveryDto;
  };
}

export const setDeliveryPageByDtoDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { deliveryDto } = action.payload;
  const newDelivery = convertDeliveryDtoToDelivery(deliveryDto);

  const index = state.deliveryPage.contents.findIndex((delivery: Delivery) => {
    return delivery.id === newDelivery.id;
  });

  if (index !== -1) {
    state.deliveryPage.contents[index] = newDelivery;
  } else {
    state.deliveryPage = {
      ...state.deliveryPage,
      contents: [newDelivery, ...state.deliveryPage.contents.slice(0, 9)],
    };
  }
};
